import React, {Component} from "react";
import ColorHexMapCtx from "../contexts/ColorHexMapCtx";

export default (OriginalComponent) =>
  class ColorHexMapContextComponent extends Component {
    render() {
      return (
        <ColorHexMapCtx.Consumer>
          {(colorHexMap) => (
            <OriginalComponent
              colorHexMap={colorHexMap}
              {...this.props}
              {...this.state}
            />
          )}
        </ColorHexMapCtx.Consumer>
      );
    }
  };
